import {ROUTES} from '../routes';
import {
  RoutePatternCreate,
  RoutePatternUpdate,
} from './route-pattern-create-update';
import {RoutePatternListing} from './route-pattern-listing';
import {RouteObject} from 'react-router';
import {ProtectedRoute} from '../auth/require-authorization';

export const RoutePatternRoutes: RouteObject = {
  path: ROUTES.ADMIN.ROUTE_PATTERNS.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.ROUTE_PATTERNS.INDEX.path,
      element: <RoutePatternListing />,
    },
    {
      path: ROUTES.ADMIN.ROUTE_PATTERNS.CREATE.path,
      element: <RoutePatternCreate />,
    },
    {
      path: ROUTES.ADMIN.ROUTE_PATTERNS.DETAIL.path,
      element: <RoutePatternUpdate />,
    },
  ]
};